import React, {useEffect, useMemo, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import CONFIGURACIONES from "../../../util/constants";
import WaveButton from "../WaveButton.jsx";

const EvaluacionCualitativaModal = ({ show, onClose, onSave, showCreate, title, categoriasEvaluacion, initDataEvaluacionCualitativa }) => {
    const { handleSubmit: handleSubmitModal, reset: resetModal, register: registerModal, getValues: getValuesModal, setValue : setValueModal, formState: { errors: errorsModal } } = useForm({mode: "onChange"});

    const detallesSolvenciaMoral = useMemo(() => {
        return categoriasEvaluacion.filter(categoria => categoria.aplicado_a == CONFIGURACIONES.INIT.LIST_CATEGORIAS.CLASIFICACION_SOLVENCIA_MORAL);
    }, [categoriasEvaluacion]);

    const detallesCapacidadGestion = useMemo(() => {
        return categoriasEvaluacion.filter(categoria => categoria.aplicado_a == CONFIGURACIONES.INIT.LIST_CATEGORIAS.CLASIFICACION_CAPACIDAD_GESTION);
    }, [categoriasEvaluacion]);

    const fnCalcularPuntajeUnidadFamiliar = () => {
        let acumuladoPtje = 0;
        detallesSolvenciaMoral.map(itm => {
            let calificacion = getValuesModal(`calificacion_${itm.id}`)
             
            acumuladoPtje += (calificacion != CONFIGURACIONES.INIT.STRING?parseFloat(calificacion):0);
        })
        setValueModal('ptjeUnidadFamiliar', acumuladoPtje);
        fnCalcularPromedio();
    };

    const fnCalcularPuntajeGestionNegocio = () => {
        let acumuladoPtje = 0;
        detallesCapacidadGestion.map(itm => {
            let calificacion = getValuesModal(`calificacion_${itm.id}`)
             
            acumuladoPtje += (calificacion != CONFIGURACIONES.INIT.STRING?parseFloat(calificacion):0);
        })
        setValueModal('ptjeGestionNegocio', acumuladoPtje);
        fnCalcularPromedio();
    };

    const fnCalcularPromedio = () => {
        let unidadFamiliar = getValuesModal('ptjeUnidadFamiliar');
        let gestionNegocio = getValuesModal('ptjeGestionNegocio');

        if (unidadFamiliar == CONFIGURACIONES.INIT.STRING || gestionNegocio == CONFIGURACIONES.INIT.STRING) { return; }
        
        setValueModal('ptjePromedioEvaluacion', ((unidadFamiliar + gestionNegocio)/2).toFixed(2));
    };

    const saveData = (form2) => {
        let detalles = []
        detallesSolvenciaMoral.map(itm => {
            detalles.push({
                'nombre': getValuesModal(`nombre_${itm.id}`),
                'calificacion': getValuesModal(`calificacion_${itm.id}`),
                'tipo': getValuesModal(`tipo_${itm.id}`),
                'categoriaEvaluacionId': itm.id
            });
        });

        detallesCapacidadGestion.map(itm => {
            detalles.push({
                'nombre': getValuesModal(`nombre_${itm.id}`),
                'calificacion': getValuesModal(`calificacion_${itm.id}`),
                'tipo': getValuesModal(`tipo_${itm.id}`),
                'categoriaEvaluacionId': itm.id
            });
        });

        let estadoCivil = (initDataEvaluacionCualitativa.registradoPreviamente == CONFIGURACIONES.INIT.STRING_N?initDataEvaluacionCualitativa.estadoCivil: initDataEvaluacionCualitativa.evaluacion.estadoCivil);
        
        let form = {
            'estadoCivil': estadoCivil,
            'apreciacionesAsesor': form2.apreciacionesAsesor,
            'experienciaNegocio': form2.experienciaNegocio,
            'nroDependientes': form2.nroDependientes,
            'nroHijos': form2.nroHijos,
            'ptjeGestionNegocio': form2.ptjeGestionNegocio,
            'ptjeUnidadFamiliar': form2.ptjeUnidadFamiliar,
            'ptjePromedioEvaluacion': form2.ptjePromedioEvaluacion,
            'tipoLocal': form2.tipoLocal,
            'tipoMaterialLocal': form2.tipoMaterialLocal,
            'materialVivienda': form2.materialVivienda,
            'tipoVivienda': form2.tipoVivienda,
            'antiguedadLocal': form2.antiguedadLocal,
            'detalles': detalles,
        };
        // form['detalles'] = detalles;
        onSave(form);
    };

    useEffect(() => {
        resetModal();
        if (initDataEvaluacionCualitativa != CONFIGURACIONES.INIT.NULL) {
            if (initDataEvaluacionCualitativa.registradoPreviamente == CONFIGURACIONES.INIT.STRING_N) {
                setValueModal('estadoCivil', initDataEvaluacionCualitativa.estadoCivil);
                setValueModal('tipoVivienda', initDataEvaluacionCualitativa.tipoVivienda);
                setValueModal('nroDependientes', initDataEvaluacionCualitativa.numIntegrantesFamilia);
            } else {
                let evaluacion = initDataEvaluacionCualitativa.evaluacion;
                setValueModal('estadoCivil', evaluacion.estadoCivil);
                setValueModal('apreciacionesAsesor', evaluacion.apreciacionesAsesor);
                setValueModal('experienciaNegocio', evaluacion.experienciaNegocio);
                setValueModal('nroDependientes', evaluacion.nroDependientes);
                setValueModal('nroHijos', evaluacion.nroHijos);
                setValueModal('ptjeGestionNegocio', evaluacion.ptjeGestionNegocio);
                setValueModal('ptjeUnidadFamiliar', evaluacion.ptjeUnidadFamiliar);
                setValueModal('ptjePromedioEvaluacion', evaluacion.ptjePromedioEvaluacion);
                setValueModal('tipoLocal', evaluacion.tipoLocal);
                setValueModal('tipoMaterialLocal', evaluacion.tipoMaterialLocal);
                setValueModal('tipoVivienda', evaluacion.tipoVivienda);
                setValueModal('antiguedadLocal', evaluacion.antiguedadLocal);
                setValueModal('materialVivienda', evaluacion.materialVivienda);
                
                let detalles = initDataEvaluacionCualitativa.detalles;
                detalles.map(itm => {
                    setValueModal(`nombre_${itm.categoriaEvaluacionId}`, itm.nombre);
                    setValueModal(`calificacion_${itm.categoriaEvaluacionId}`, itm.calificacion);
                    setValueModal(`tipo_${itm.categoriaEvaluacionId}`, itm.tipo);
                });
                
            }
            
        }
    }, [initDataEvaluacionCualitativa]);

    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-xl modal-xxl modal-dialog-centered" role="document">
                <form className="modal-content" action="" onSubmit={handleSubmitModal(saveData)} autoComplete="off">
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h3 className="h4 text-bold">Unidad Familiar</h3>
                                    </div>

                                    <div className="col-sm-12 col-md-6">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="estadoCivil" className="control-label col-form-label">Estado Civil <span className="text-danger">*</span></label>
                                                    <select
                                                        {...registerModal("estadoCivil", {
                                                            required: OWASP.REQUIRED,
                                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE
                                                        })} className="form-control" id="estadoCivil" defaultValue={""} 
                                                    >
                                                        <option value="" disabled>Seleccione</option>
                                                        {
                                                            CONFIGURACIONES.INIT.LIST.ESTADOS_CIVIL.map((el, index) => (
                                                                <option key={index} value={el.id}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errorsModal.estadoCivil && errorsModal.estadoCivil.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-sm-12 col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="tipoVivienda" className="control-label col-form-label">Tipo de Vivienda <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="tipoVivienda"
                                                        id="tipoVivienda"
                                                        readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                        {...registerModal("tipoVivienda", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.GENERAL,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            }
                                                        })}
                                                    />
                                                    <small className="invalid-feedback"> { errorsModal.tipoVivienda && errorsModal.tipoVivienda.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-sm-12 col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="materialVivienda" className="control-label col-form-label">Material <span className="text-danger">*</span></label>
                                                    <select
                                                        {...registerModal("materialVivienda", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.GENERAL,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            },
                                                            onChange: (e) => {
                                                            }
                                                        })} className="form-control" id="materialVivienda"  defaultValue={""}
                                                    >
                                                        <option value="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE}>Seleccione</option>
                                                        {
                                                            CONFIGURACIONES.INIT.LIST.TIPOS_MATERIAL_VIVIENDA.map((el, index) => (
                                                                <option key={index} value={el.id}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errorsModal.materialVivienda && errorsModal.materialVivienda.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-sm-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="nroHijos" className="control-label col-form-label">N° de Hijos <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="nroHijos"
                                                        id="nroHijos"
                                                        {...registerModal("nroHijos", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            }
                                                        })}
                                                    />
                                                    <small className="invalid-feedback"> { errorsModal.nroHijos && errorsModal.nroHijos.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-sm-12 col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="nroDependientes" className="control-label col-form-label">N° de Dependientes <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="nroDependientes"
                                                        id="nroDependientes"
                                                        {...registerModal("nroDependientes", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            }
                                                        })}
                                                    />
                                                    <small className="invalid-feedback"> { errorsModal.nroDependientes && errorsModal.nroDependientes.message }</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-6 mt-2">
                                        <table className="table table-sm compact-table align-middle text-wrap mb-1">
                                            <thead className="bg-success text-white">
                                                <tr>
                                                    <th className="p-2 text-center">Solvencia Moral</th>
                                                    <th className="p-2 text-center">Calificación</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {detallesSolvenciaMoral.length > 0? (
                                                detallesSolvenciaMoral.map((item) => (
                                                    <tr key={item.id}>                            
                                                        <td className="p-2 text-center">{item.nombre}</td>
                                                        
                                                        <td className="p-2 text-center">
                                                            <input type="hidden" 
                                                                {...registerModal(`nombre_${item.id}`,   {
                                                                    required: OWASP.REQUIRED, 
                                                                    value: item.nombre
                                                                })} 
                                                            />

                                                            <input type="hidden" 
                                                                {...registerModal(`tipo_${item.id}`,   {
                                                                    required: OWASP.REQUIRED, 
                                                                    value: CONFIGURACIONES.INIT.LIST_TIPO_DETALLE.UNIDAD_FAMILIAR
                                                                })} 
                                                            />
                                                            <select
                                                                {...registerModal(`calificacion_${item.id}`, {
                                                                    required: OWASP.REQUIRED,
                                                                    pattern: {
                                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                        message: OWASP.MESSAGES.DEFAULT
                                                                    },
                                                                    onChange: (e) => {
                                                                        fnCalcularPuntajeUnidadFamiliar()
                                                                    }
                                                                })} className="form-control form-control-sm" name={`calificacion_${item.id}`} id={`calificacion_${item.id}`} 
                                                                defaultValue={""}
                                                            >
                                                                <option value="" disabled>Seleccione</option>
                                                                {
                                                                    CONFIGURACIONES.INIT.LIST.ESCALAS_CALIFICACION.map((el, index) => (
                                                                        <option key={index} value={el.id}>{el.nombre}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                            <small className="invalid-feedback"> { errorsModal[`calificacion_${item.id}`]?.message}</small>
                                                        </td>
                                                    </tr>
                                                ))
                                            ): (
                                                    <tr>
                                                        <td colSpan="2" className="text-center text-muted">
                                                            <span className="text-danger">No se encontraron resultados</span>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                            </tbody>
                                        </table>

                                        <div className="row">
                                            <div className="col-sm-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="ptjeUnidadFamiliar" className="control-label col-form-label text-success">Puntaje <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="ptjeUnidadFamiliar"
                                                        id="ptjeUnidadFamiliar"
                                                        readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                        {...registerModal("ptjeUnidadFamiliar", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            }
                                                        })}
                                                    />
                                                    <small className="invalid-feedback"> { errorsModal.ptjeUnidadFamiliar && errorsModal.ptjeUnidadFamiliar.message }</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-12 mt-2">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h3 className="h4 text-bold">Gestión del Negocio</h3>
                                    </div>

                                    <div className="col-sm-12 col-md-6">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="tipoLocal" className="control-label col-form-label">Tipo de Local <span className="text-danger">*</span></label>
                                                    <select
                                                        {...registerModal("tipoLocal", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.GENERAL,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            },
                                                            onChange: (e) => {
                                                            }
                                                        })} className="form-control" id="tipoLocal"  defaultValue={""}
                                                    >
                                                        <option value="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE}>Seleccione</option>
                                                        {
                                                            CONFIGURACIONES.INIT.LIST.TIPOS_LOCAL.map((el, index) => (
                                                                <option key={index} value={el.id}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errorsModal.tipoLocal && errorsModal.tipoLocal.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-sm-12 col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="tipoMaterialLocal" className="control-label col-form-label">Material <span className="text-danger">*</span></label>
                                                    <select
                                                        {...registerModal("tipoMaterialLocal", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.GENERAL,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            },
                                                            onChange: (e) => {
                                                            }
                                                        })} className="form-control" id="tipoMaterialLocal"  defaultValue={""}
                                                    >
                                                        <option value="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE}>Seleccione</option>
                                                        {
                                                            CONFIGURACIONES.INIT.LIST.TIPOS_MATERIAL_VIVIENDA.map((el, index) => (
                                                                <option key={index} value={el.id}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errorsModal.tipoMaterialLocal && errorsModal.tipoMaterialLocal.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-sm-12 col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="antiguedadLocal" className="control-label col-form-label">Antigüedad en Local <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="antiguedadLocal"
                                                        id="antiguedadLocal"
                                                        {...registerModal("antiguedadLocal", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            }
                                                        })}
                                                    />
                                                    <small className="invalid-feedback"> { errorsModal.antiguedadLocal && errorsModal.antiguedadLocal.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-sm-12 col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="experienciaNegocio" className="control-label col-form-label">Experiencia en el Negocio <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="experienciaNegocio"
                                                        id="experienciaNegocio"
                                                        {...registerModal("experienciaNegocio", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            }
                                                        })}
                                                    />
                                                    <small className="invalid-feedback"> { errorsModal.experienciaNegocio && errorsModal.experienciaNegocio.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-sm-12 col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="apreciacionesAsesor" className="control-label col-form-label">Apreciaciones del Asesor <span className="text-danger">*</span></label>
                                                    <textarea
                                                        rows="5"
                                                        className="form-control no-resize"
                                                        name="apreciacionesAsesor"
                                                        id="apreciacionesAsesor"
                                                        {...registerModal("apreciacionesAsesor", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.GENERAL,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            }
                                                        })}
                                                    />
                                                    <small className="invalid-feedback"> { errorsModal.apreciacionesAsesor && errorsModal.apreciacionesAsesor.message }</small>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="ptjePromedioEvaluacion" className="control-label col-form-label text-info">Promedio <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="ptjePromedioEvaluacion"
                                                        id="ptjePromedioEvaluacion"
                                                        readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                        {...registerModal("ptjePromedioEvaluacion", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_DECIMAL_INCLUDE_ZERO,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            }
                                                        })}
                                                    />
                                                    <small className="invalid-feedback"> { errorsModal.ptjePromedioEvaluacion && errorsModal.ptjePromedioEvaluacion.message }</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-6 mt-2">
                                       <table className="table table-sm table-hover compact-table align-middle text-wrap mb-1">
                                            <thead className="bg-success text-white">
                                                <tr>
                                                    <th className="p-2 text-center">Capacidad de Gestión</th>
                                                    <th className="p-2 text-center">Calificación</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {detallesCapacidadGestion.length > 0? (
                                                    detallesCapacidadGestion.map((item) => (
                                                        <tr key={item.id}>                            
                                                            <td className="p-2 text-center">{item.nombre}</td>
                                                            <td className="p-2 text-center">
                                                                <input type="hidden" 
                                                                    {...registerModal(`nombre_${item.id}`,   {
                                                                        required: OWASP.REQUIRED, 
                                                                        value: item.nombre
                                                                    })} 
                                                                />

                                                                <input type="hidden" 
                                                                    {...registerModal(`tipo_${item.id}`,   {
                                                                        required: OWASP.REQUIRED, 
                                                                        value: CONFIGURACIONES.INIT.LIST_TIPO_DETALLE.GESTION_NEGOCIO
                                                                    })} 
                                                                />

                                                                <select
                                                                    {...registerModal(`calificacion_${item.id}`, {
                                                                        required: OWASP.REQUIRED,
                                                                        pattern: {
                                                                            value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                            message: OWASP.MESSAGES.DEFAULT
                                                                        },
                                                                        onChange: (e) => {
                                                                            fnCalcularPuntajeGestionNegocio();
                                                                        }
                                                                    })} className="form-control form-control-sm" name={`calificacion_${item.id}`} id={`calificacion_${item.id}`} 
                                                                    defaultValue={""}
                                                                >
                                                                    <option value="" disabled>Seleccione</option>
                                                                    {
                                                                        CONFIGURACIONES.INIT.LIST.ESCALAS_CALIFICACION.map((el, index) => (
                                                                            <option key={index} value={el.id}>{el.nombre}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                                <small className="invalid-feedback"> { errorsModal[`calificacion_${item.id}`]?.message}</small>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ): (
                                                        <tr>
                                                            <td colSpan="2" className="text-center text-muted">
                                                                <span className="text-danger">No se encontraron resultados</span>
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                       </table>
                                        
                                       <div className="row">
                                            <div className="col-sm-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="ptjeGestionNegocio" className="control-label col-form-label text-success">Puntaje <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="ptjeGestionNegocio"
                                                        id="ptjeGestionNegocio"
                                                        readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                        {...registerModal("ptjeGestionNegocio", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            }
                                                        })}
                                                    />
                                                    <small className="invalid-feedback"> { errorsModal.ptjeGestionNegocio && errorsModal.ptjeGestionNegocio.message }</small>
                                                </div>
                                            </div>
                                       </div>
                                      
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={onClose}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showCreate && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect">
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default EvaluacionCualitativaModal;
